export type DashboardOrigin = 'group' | 'location';

export type GroupLocationDashboardContext = {
  entityType: DashboardOrigin;
  entityId: number;
};

const STORAGE_KEY = 'groupLocationDashboardContext';

const isBrowser = () => typeof window !== 'undefined' && typeof window.sessionStorage !== 'undefined';

export const saveGroupLocationDashboardContext = (context: GroupLocationDashboardContext) => {
  if (!isBrowser()) return;
  try {
    window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(context));
  } catch {
    // Intentionally ignore storage errors.
  }
};

export const loadGroupLocationDashboardContext = (): GroupLocationDashboardContext | null => {
  if (!isBrowser()) return null;
  try {
    const rawValue = window.sessionStorage.getItem(STORAGE_KEY);
    if (!rawValue) return null;
    const parsedValue = JSON.parse(rawValue);
    if (
      typeof parsedValue?.entityId === 'number' &&
      (parsedValue?.entityType === 'group' || parsedValue?.entityType === 'location')
    ) {
      return parsedValue as GroupLocationDashboardContext;
    }
    return null;
  } catch {
    return null;
  }
};
